/*
 * Bozza di un abbonamento (subscriptionsedit/:id): e' la stessa pagina unica del nuovo abbonamento
 * (new.js), che con l'id carica la bozza, la aggiorna e permette di eliminarla.
 */
import { SubscriptionsNew } from "./new";

export const SubscriptionsEdit = SubscriptionsNew;
export default SubscriptionsEdit;
